import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

export const outlineStyle = defineStyle((props) => ({
  bg: "transparent",
  color: mode("#cccccc", "#cccccc")(props),
  borderColor: mode("#cccccc", "#cccccc")(props),
  _hover: { color: "brand.hover", borderColor: "brand.hover", bg: "#323232" },
  _active: { color: "brand.active", borderColor: "brand.active", bg: "#323232" },
  _disabled: {
    bg: "transparent",
    color: "#cccccc",
    borderColor: "#cccccc",
  },
  /** 暗色模式的显式写法， 用 mode 更简短，参考了源码使用的 mode，但觉得显式写法可读性好，所以保留注释 */
  // _dark: {
  //   color: "#cccccc",
  //   borderColor: "#cccccc",
  // },
}));

export const linkStyle = defineStyle((props) => ({
  bg: "transparent",
  color: mode("#cccccc", "#cccccc")(props),
  border: "none",
  _hover: { color: "brand.hover", border: "none", textDecoration: "unset" },
  _active: { color: "brand.active", border: "none", textDecoration: "unset" },
}));

export const darkSolidStyle = defineStyle(() => ({
  bg: "#585858",
  color: "white",
  borderRadius: "4px",
  fontSize: "14px",
  borderColor: "#585858",
  _hover: { bg: "#434343", borderColor: "#585858" },
  _active: { bg: "#313131", borderColor: "#585858" },
}));

export const textStyle = defineStyle((props) => ({
  color: mode("#ffffff", "#ffffff")(props),
  fontSize: "12px",
  fontWeight: 400,
  border: "1px",
  borderColor: "transparent",
  bg: "transparent",
  transition: "all 0.3s cubic-bezier(.08,.52,.52,1)",
  _hover: {
    color: "brand.primary",
    borderColor: "brand.primary",
    bg: "transparent",
  },
  _active: {
    color: "brand.primary",
    borderColor: "brand.primary",
    bg: "transparent",
  },
}));

export const primaryStyle = defineStyle({
  bg: "brand.primary",
  color: "white",
  borderColor: "brand.primary",
  _hover: {
    bg: "brand.hover",
    borderColor: "brand.hover",
    _disabled: {
      bg: "brand.disabled",
    },
  },
  _active: { bg: "brand.active", borderColor: "brand.active" },

  _disabled: {
    bg: "brand.disabled",
    opacity: 1,
  },
});

export const ButtonTheme = defineStyleConfig({
  baseStyle: (props) => ({
    fontWeight: 500,
    border: "1px",
    borderRadius: "4px",
    fontStyle: "normal",
    textAlign: "center",
    outline: "none",
    cursor: "pointer",
    _focusVisible: {
      boxShadow: "none",
      outline: "none",
    },
  }),
  sizes: {
    sm: {
      h: "32px",
      fontSize: "12px",
      p: "4px 8px",
      borderRadius: "2px",
    },
    md: {
      h: "42px",
      fontSize: "14px",
      p: " 8px 16px",
    },
  },
  variants: {
    /** @TODO 还有 ghost, link 没有定义 */
    outline: outlineStyle,
    primary: primaryStyle,
    text: textStyle,
    ["dark.solid"]: darkSolidStyle,
    link: linkStyle,
  },
  defaultProps: {
    size: "md",
    variant: "primary",
  },
});
